export default __webpack_public_path__ + "static/media/cloud-4.7a852b47.webp";